// extracted by mini-css-extract-plugin
module.exports = {"badgeGroupContainer":"StatusTagGroup_badgeGroupContainer__oSBff","badgeWrapper":"StatusTagGroup_badgeWrapper__bzBgs"};